import { render, staticRenderFns } from "./prestation.html?vue&type=template&id=6fc77fb0&scoped=true&external"
import script from "./prestation.js?vue&type=script&lang=js&external"
export * from "./prestation.js?vue&type=script&lang=js&external"
import style0 from "./prestation.scss?vue&type=style&index=0&id=6fc77fb0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc77fb0",
  null
  
)

export default component.exports